<div class="project-structure">

  <table mat-table [dataSource]="datasource" class="mat-elevation-z8" matSort #tableSort="matSort"
  (matSortChange)="sortChanged($event)" matSortActive="{{sortColumn}}" [matSortDirection]="sortDirection">

    <ng-container *ngFor="let col of displayedColumns; let colIndex = index">
      <ng-container *ngIf="col !== 'positionActions'" matColumnDef="{{col}}">
          <th mat-header-cell *matHeaderCellDef class="test {{tableHeaderAlignments[colIndex]}}" mat-sort-header>{{col | translate: [col, translationService.language]}}</th>
          <td mat-cell *matCellDef="let element" class="text-selection {{tableAlignments[colIndex]}}">{{retrieveValueForColumn(colIndex, element)}}</td>
      </ng-container>

      <ng-container *ngIf="col === 'positionActions'" matColumnDef="positionActions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="table-actions">
            <button mat-icon-button (click)="editPosition(element)">
              <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
            </button>
            <button mat-icon-button (click)="deletePosition(element)">
                <sc-action-icon iconClass="fa-trash"></sc-action-icon>
            </button>
          </div>
        </td>
      </ng-container>
    </ng-container>

    <!-- Group header -->
    <ng-container matColumnDef="groupHeader">
      <td [attr.colspan]="displayedColumns.length" mat-cell *matCellDef="let header" class="text-selection">
        <sc-flex >
          <div>{{header.name}}</div>
          <sc-content-spacer [grow]="true"></sc-content-spacer>
          <div>
            <button mat-icon-button (click)="editPart(header.projectPart)">
              <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
            </button>
            <button mat-icon-button (click)="addPart(header.projectPart)">
                <sc-action-icon iconClass="fa-folder-plus"></sc-action-icon>
            </button>
            <button mat-icon-button (click)="deletePart(header.projectPart)">
                <sc-action-icon iconClass="fa-trash"></sc-action-icon>
            </button>
            <button mat-icon-button (click)="addPosition(header.projectPart)">
                <sc-action-icon iconClass="fa-plus"></sc-action-icon>
            </button>
          </div>
        </sc-flex>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-row *matRowDef="let row; columns: ['groupHeader']; when: isHeader"> </tr>

  </table>

</div>
